import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import { UserProperties } from '../interfaces/userProperties';
import { LoggingService, LogAppSection } from '../services/logging.service';

@Injectable()
export class FirebaseService {
  appId = environment.firebaseConfig.appId;
  userId;
  up: UserProperties = {};
  meta = {
    paymentMethod: '',
    albumSize: '',
    albumPicsVolume: '',
  };

  constructor(private loggingService: LoggingService) {}

  init() {
    firebase.initializeApp(environment.firebaseConfig);
    firebase.analytics();
  }

  logEvent(event, params = {}) {
    if (!this.appId) {
      return;
    }

    firebase.analytics().logEvent(event, params);

    this.loggingService.log(
      `Firebase ${event} (params: ${JSON.stringify(params)})`,
      { appSection: LogAppSection.Analytics }
    );
  }

  getUserId = () => {
    return this.userId;
  };

  setUserId(id) {
    if (!this.appId) {
      return;
    }

    firebase.analytics().setUserId(id);
    this.userId = id;
    this.loggingService.log(`Firebase userId: ${id}`, {
      appSection: LogAppSection.Analytics,
    });

    let updatedProperties;
    if (id === '') {
      updatedProperties = {
        user_id: '',
        authenticated: false,
        story_count: null,
        order_count: null,
        print_count: null,
      };
    } else {
      updatedProperties = {
        user_id: id,
        authenticated: !!id,
      };
    }
    this.userProperties(updatedProperties);
  }

  userProperties(params) {
    if (!this.appId || !params) {
      return;
    }

    let needUpdating = false;

    for (const el of Object.keys(params)) {
      if (this.up[el] !== params[el]) {
        this.up[el] = params[el];
        needUpdating = true;
      }
    }

    if (needUpdating) {
      firebase.analytics().setUserProperties(params);
      this.loggingService.log(
        `Firebase updated user properties: ${JSON.stringify(this.up)}`,
        { appSection: LogAppSection.Analytics }
      );
    }
  }
}
